import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { publicHelpers } from 'globals/helpers/public-helpers';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'code-dialog',
    template: `
<div class="code-dialog">
  <icon icon="close" class="close" (click)="dialogRef.close()"></icon>
  <div class="title" [ngClass]="{withDescription: !!data.description}" *ngIf="data.title">{{ data.title }}</div>
  <div *ngIf="data.description" class="description" [innerHTML]="helpers.strWithBreak(data.description)"></div>
  <div class="code">{{ data.code }}</div>
  <div class="submit">
    <div style="flex:1;"></div>
    <div class="success" *ngIf="copied">{{ data.successMessage }}</div>
    <button mat-button color="primary" (click)="copyCode()">{{ data.copyText }}</button>
  </div>
</div>
`,
    styleUrls: ['code.dialog.scss'],
    standalone: true,
    imports: [IconComponent, MatButtonModule, CommonModule],
})

export class CodeDialogComponent {
  helpers = publicHelpers
  copied = false

  constructor(
    public dialogRef: MatDialogRef<CodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CodeDialogData,
  ) { }

  copyCode() {
    navigator['clipboard'].writeText(this.data.code)
    this.copied = true
    setTimeout(() => this.copied = false, 3000)
  }
}

export interface CodeDialogData {
  title?: string
  description?: string
  code: string
  copyText: string
  successMessage: string
}